export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    $(document).ready(function () {
      $('.testimonial-slider').slick({
        slidesToShow: 3,
        centerMode: true,
        centerPadding: 0,
        slidesToScroll: 1,
        adaptiveHeight: false,
        arrows: true,
        autoplay: false,
        responsive: [{
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
        ],
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js